export default __webpack_public_path__ + "static/media/car-left.561c766d.svg";